// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { ClarityTranslationFragmentDoc } from './ClarityTranslation.fragment.generated';
export const StoneClarityFragmentDoc = gql`
    fragment stoneClarity on StoneClarity {
  abbreviation
  systemCode
  translation(locale: $locale) {
    ...clarityTranslation
  }
}
    ${ClarityTranslationFragmentDoc}`;